import { moduleProviderFactory } from 'core/providers';
import { ChannelList, ChannelEdit } from 'modules/channel/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.channel',
				pattern: '/channels',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.channel.list',
						pattern: '',
						authorization: 'channelSection.full',
						component: ChannelList,
					},
					{
						name: 'master.app.main.channel.add',
						pattern: '/add',
						component: ChannelEdit,
					},
					{
						name: 'master.app.main.channel.edit',
						pattern: '/edit/:id',
						component: ChannelEdit,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/channel/config.js